import { useBlocker } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import CustomModal from "../../global/CustomModal/CustomModal";
import CustomButton from "../../global/Button/CustomButton";

export default function useConfirmNavigation(shouldBlock, onConfirm, isSubmitting = false) {
  const shouldBlockRef = useRef(shouldBlock);
  const [isHandling, setIsHandling] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    shouldBlockRef.current = shouldBlock;
  }, [shouldBlock]);

  const blocker = useBlocker(() => shouldBlockRef.current && !isSubmitting);

  useEffect(() => {
    if (blocker.state === "blocked" && !isHandling) {
      setIsHandling(true);
      setIsModalOpen(true);
    }
  }, [blocker, isHandling]);

  useEffect(() => {
    if (blocker.state === "unblocked") {
      setIsModalOpen(false);
      setIsHandling(false);
    }
  }, [blocker.state]);

  const handleConfirm = async () => {
    try {
      await onConfirm();
      setIsModalOpen(false);
      blocker.proceed();
    } catch (err) {
      console.error("Auto-submit failed", err);
    } finally {
      setIsHandling(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsHandling(false);
    blocker.reset();
  };

  const ConfirmModal = (
    <CustomModal
      visible={isModalOpen}
      onClose={handleCancel}
      title="Leave Quiz?"
    >
      <p className="text-[#5D5D5D] text-sm mb-6">
        If you leave, your quiz will be auto-submitted.
      </p>
      <div className="flex justify-end gap-3">
        <CustomButton variant="outlined" onClick={handleCancel}>
          Stay on Quiz
        </CustomButton>
        <CustomButton variant="primary" onClick={handleConfirm}>
          Submit & Leave
        </CustomButton>
      </div>
    </CustomModal>
  );

  return { ConfirmModal };
}